<template>
  <div>
    <!-- Advertisers Area -->
    <div class="advertisersAreaContainer" v-if="currentView === 'advertisers'">
      <div v-if="user && user.types.advertiser && authView === 'userView'"></div>
      <div v-else>
        <div v-if="user && authView === 'userView'">
          <div class="sectionHeader" style="text-align:center;">
            <h5>Advertiser Area</h5>
          </div>
          <div class="whiteContainer">
            <div class="w3-center">
              <p>Please read the Terms and use the button below to agree and signup to advertise on the site.</p>
              <button v-if="user && !user.types.advertiser" @click="becomeAdvertiser()" class="w3-button w3-green w3-block">
                <span>Agree and Become an Advertiser</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Organizers Area -->
    <div class="organizersAreaContainer" v-if="currentView === 'organizers'">
      <template v-if="user && user.types.organizer && authView === 'userView'">
        <div class="sectionHeader" style="text-align:center;">
          <h5>Accept Payments</h5>
        </div>
        <div class="whiteContainer">
          <div class="w3-center">
            <div v-if="!user.hasStripe">
              <p>You must signup or connect a Stripe Account in order to receive payments for advertisments on your event page.</p>
              <button @click="stripeConnect" class="w3-button w3-blue w3-block">
                <span>Stripe Connect</span>
              </button>
            </div>
            <div v-if="user.hasStripe">
              <div style="text-align:center">
                <span style="font-size:1em; font-weight:400; color:#666;">Payments Setup Successfully</span>
                <p><b>{{user.stripeAcct.email}}</b></p>
              </div>
              <button @click="stripeLogout()" class="w3-button w3-red w3-block">
                <span>Disconnect Stripe</span>
              </button>
            </div>
          </div>
        </div>
      </template>
      <template v-if="user && !user.types.organizer">
        <div class="sectionHeader" style="text-align:center;">
          <h5>Organizer Area</h5>
        </div>
        <div class="whiteContainer">
          <div class="w3-center">
            <p>Please read the Posting Guidelines and use the button below to agree and signup to post events on the site.</p>
            <button @click="becomeOrganizer()" class="w3-button w3-green w3-block">
              <span>Agree and Become an Organizer</span>
            </button>
          </div>
        </div>
      </template>
    </div>

    <!-- User Area -->
    <div class="userAreaContainer">
      <div class="sectionHeader" style="text-align:center;">
        <h5>User Area</h5>
      </div>
      <div class="whiteContainer" v-if="authView !== 'verifyEmailView'">
        <div class="w3-center">
          <div v-if="user && authView === 'userView'">
            <p><b>{{user.email}}</b></p>

            <button @click="logout()" class="w3-button w3-red w3-block">
              <span>Logout</span>
            </button>
          </div>

          <div v-if="!isAuth">
            <div v-if="authView === 'defaultView'">
              <button class="w3-button w3-green w3-block" @click="viewOpen('loginView')">
                <span>Login</span>
              </button>
              <button class="w3-button w3-cyan w3-block" @click="viewOpen('registerView')">
                <span>Register</span>
              </button>
              <p v-if="authView === 'verifyEmailView'" style="font-size:14px; text-align:center; margin-top:10px">Please check your email for a verification link. Once you've verified your email you can login here.</p>
            </div>

            <div v-if="authView === 'loginView'">
              <input type="text" v-model="email" class="w3-input" id="email" placeholder="Email" :style="hasError.email">
              <input type="password" v-model="password" class="w3-input w3-margin-bottom" id="password" placeholder="Password" @keyup.enter="login()" :style="hasError.password">
              <div class="errorMessageContainer w3-margin-bottom" v-if="errorMessage">
                <h5 class="text-danger">{{errorMessage}}</h5>
              </div>
              <div class="w3-row">
                <div class="w3-col s12">
                  <button class="w3-button rounded-w3-button w3-green w3-block" @click="login()">Login</button>
                </div>
              </div>
              <div class="w3-row">
                <div class="w3-col s12 m6">
                  <button class="w3-button rounded-w3-button w3-red w3-block" @click="viewOpen('defaultView')">Cancel</button>
                </div>
                <div class="w3-col s12 m6">
                  <button class="w3-button rounded-w3-button w3-dark-grey w3-block" @click="resetPassword(email)" :disabled="passwordReset === true">
                    <span v-if="passwordReset === true">Email Sent</span>
                    <span v-if="passwordReset === false">Reset Password</span>
                  </button>
                </div>
              </div>
            </div>

            <div v-if="authView === 'registerView'">
              <div class="w3-row">
                <div class="w3-col s12 m6">
                  <input type="text" v-model="contact.firstName" class="w3-input" id="firstName" placeholder="First Name">
                </div>
                <div class="w3-col s12 m6">
                  <input type="text" v-model="contact.lastName" class="w3-input" id="lastName" placeholder="Last Name">
                </div>
              </div>
              
              <input type="text" v-model="contact.company" class="w3-input" id="company" placeholder="Company">
              <input type="text" v-model="contact.street" class="w3-input" id="street" placeholder="Street Address">

              <div class="w3-row" style="margin-bottom:8px;">
                <div class="w3-col s12 m4">
                  <input type="text" v-model="contact.city" class="w3-input" id="city" placeholder="City">
                </div>
                <div class="w3-col s12 m4">
                  <select class="w3-select" v-model="contact.state" id="state">
                    <option value="AL">Alabama</option><option value="AK">Alaska</option><option value="AZ">Arizona</option><option value="AR">Arkansas</option><option value="CA">California</option><option value="CO">Colorado</option><option value="CT">Connecticut</option><option value="DE">Delaware</option><option value="DC">District Of Columbia</option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="HI">Hawaii</option><option value="ID">Idaho</option><option value="IL">Illinois</option><option value="IN">Indiana</option><option value="IA">Iowa</option><option value="KS">Kansas</option><option value="KY">Kentucky</option><option value="LA">Louisiana</option><option value="ME">Maine</option><option value="MD">Maryland</option><option value="MA">Massachusetts</option><option value="MI">Michigan</option><option value="MN">Minnesota</option><option value="MS">Mississippi</option><option value="MO">Missouri</option><option value="MT">Montana</option><option value="NE">Nebraska</option><option value="NV">Nevada</option><option value="NH">New Hampshire</option><option value="NJ">New Jersey</option><option value="NM">New Mexico</option><option value="NY">New York</option><option value="NC">North Carolina</option><option value="ND">North Dakota</option><option value="OH">Ohio</option><option value="OK">Oklahoma</option><option value="OR">Oregon</option><option value="PA">Pennsylvania</option><option value="RI">Rhode Island</option><option value="SC">South Carolina</option><option value="SD">South Dakota</option><option value="TN">Tennessee</option><option value="TX">Texas</option><option value="UT">Utah</option><option value="VT">Vermont</option><option value="VA">Virginia</option><option value="WA">Washington</option><option value="WV">West Virginia</option><option value="WI">Wisconsin</option><option value="WY">Wyoming</option>
                  </select>
                </div>
                <div class="w3-col s12 m4">
                  <input type="text" v-model="contact.zip" class="w3-input " id="zip" placeholder="Zip">
                </div>
              </div>
              <input type="text" v-model="email" class="w3-input " id="email" placeholder="Email">
              <input type="password" v-model="password" class="w3-input " id="password" placeholder="Password" @keyup.enter="login()">
              <div class="errorMessageContainer w3-margin-bottom" v-if="errorMessage">
                <h5 class="text-danger">{{errorMessage}}</h5>
              </div>
              <div class="w3-row">
                <div class="w3-col s12 m6">
                  <button class="w3-button rounded-w3-button w3-block w3-red" @click="viewOpen('defaultView')">Cancel</button>
                </div>
                <div class="w3-col s12 m6">
                  <button class="w3-button rounded-w3-button w3-block w3-green" @click="register()">Register</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="whiteContainer" v-if="authView === 'verifyEmailView'">
        <div class="w3-row">
          <div class="w3-col s12">
            <div class="verifyEmailContainer w3-margin-bottom">
              <p>Please check your email for a confirmation from us and proceed by clicking the link.</p>
              <button :disabled="!emailButtonEnable" class="w3-button w3-blue w3-block w3-margin-bottom" @click="sendVerificationEmail()">
                <span>{{emailButtonText}}</span>
              </button>
              <button @click="logout()" class="w3-button w3-green w3-block">
                <span>Proceed to Login</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import paymentMethods from '@/components/paymentMethods.vue'
  
  export default {
    name: "userauth",
    components: {
      paymentMethods
    },
    props: ['type'],
    computed: mapState([
      'user',
      'isAuth',
      'authView'
    ]),
    data() {
      return {
        contact: {
          firstName: "",
          lastName: "",
          company: "",
          street: "",
          city: "",
          state: "FL",
          zip: ""
        },
        email: "",
        password: "",
        passwordReset: false,
        hasError: {},
        errorMessage: "",
        successMessage: "",
        hideSidebar: false,
        stripeConnecting: false,
        currentView: "",
        emailButtonText: 'Resend Verification',
        emailButtonEnable: true
      }
    },
    created() {
      this.currentView = this.$router.currentRoute.name
      if (this.user) {
        this.$store.dispatch('getUserData', this.user.uid)
      }
    },
    methods: {
      register() {
        let postData = {
          contact: {
            firstName: this.contact.firstName,
            lastName: this.contact.lastName,
            company: this.contact.company,
            street: this.contact.street,
            city: this.contact.city,
            state: this.contact.state,
            zip: this.contact.zip
          },
          customer: {
            sources: {
              data: []
            }
          },
          email: this.email,
          password: this.password,
          hasStripe: false,
          approved: false,
          types: {
            organizer: true,
            advertiser: false
          }
        }
        if (!this.contact.firstName) {
          this.errorMessage = "Please enter a First Name"
          return
        }
        if (!this.contact.lastName) {
          this.errorMessage = "Please enter a Last Name"
          return
        }
        if (!this.contact.street) {
          this.errorMessage = "Please enter a Street Address for Billing"
          return
        }
        if (!this.contact.city) {
          this.errorMessage = "Please enter a City for Billing"
          return
        }
        if (!this.contact.zip) {
          this.errorMessage = "Please enter a Valid Zip Code"
          return
        }
        if (!this.email && !this.password) {
          this.errorMessage = "Please enter a valid Email and Password"
          this.hasError.email = { 'border-bottom': '2px solid #F44336' }
          this.hasError.password = { 'border-bottom': '2px solid #F44336' }
          return
        } else if (!this.email) {
          this.errorMessage = "Please enter a valid Email"
          this.hasError.email = { 'border-bottom': '2px solid #F44336' }
          return
        } else if (!this.password) {
          this.errorMessage = "Please enter a valid Password"
          this.hasError.password = { 'border-bottom': '2px solid #F44336' }
          return
        } else {
          this.$store.dispatch('register', postData).then((result) => {
            if (result.status == 'success') {
              this.$store.dispatch('login', {
                email: postData.email,
                password: postData.password
              })
            } else {
              this.errorMessage = result.message
              console.log(result)
              return
            }
          })
        }
      },
      login() {
        this.errorMessage = ''
        if (!this.email && !this.password) {
          this.errorMessage = "Please enter a valid Email and Password"
          this.hasError.email = { 'border-bottom': '2px solid #F44336' }
          this.hasError.password = { 'border-bottom': '2px solid #F44336' }
          return
        } else if (!this.email) {
          this.errorMessage = "Please enter a valid Email"
          this.hasError.email = { 'border-bottom': '2px solid #F44336' }
          return
        } else if (!this.password) {
          this.errorMessage = "Please enter a valid Password"
          this.hasError.password = { 'border-bottom': '2px solid #F44336' }
          return
        } else {
          this.$store.dispatch('login', {
            email: this.email,
            password: this.password
          }).then((result) => {
            if (result.code && result.code === 'auth/wrong-password') {
              this.errorMessage = "Incorrect User or Password"
            }
          })
        }
      },
      logout() {
        this.$store.dispatch('logout')
      },
      resetPassword(email) {
        if (!email || email === '') {
          this.errorMessage = "Please enter your email address to reset your password"
        } else {
          this.$store.dispatch('resetPassword', email).then((res) => {
            if (res === 'success') {
              this.errorMessage = "Email sent"
            } else {
              this.errorMessage = res
            }
          })
        }
      },
      becomeAdvertiser() {
        this.user.types.advertiser = true
        this.$store.dispatch('setOrganizersView', 'userView')
        this.$store.dispatch('updateUserData', this.user)
      },
      becomeOrganizer() {
        this.user.types.organizer = true
        this.$store.dispatch('updateUserData', this.user)
      },
      viewOpen(page) {
        this.$store.dispatch('setAuthView', page)
      },
      stripeConnect() {
        this.$store.dispatch('stripeConnect', this.user)
      },
      stripeLogout() {
        this.user.hasStripe = false
        this.user.stripeAcct = null
        this.$store.dispatch('updateUserData', this.user)
      },
      getStripeAcct() {
        return new Promise(resolve => {
          this.stripeService.getStripeAccount(this.user.stripeAcct.stripe_user_id).then(res => {
            resolve(res)
          })
        })
      },
      sendVerificationEmail() {
        this.$store.dispatch('sendVerificationEmail')
        this.emailButtonEnable = false
        this.emailButtonText = 'Email Sent'
        setTimeout(() => {
          this.emailButtonEnable = true
          this.emailButtonText = 'Resend Verification'
        }, 3000);
      }
    }
  }
</script>

<style>
option {font-weight:300; font-family: 'Roboto'}
</style>
